import { render } from "./LuxuryTravel05.vue?vue&type=template&id=4016f21e&scoped=true"
import script from "./LuxuryTravel05.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel05.vue?vue&type=script&lang=js"

import "./LuxuryTravel05.scss?vue&type=style&index=0&id=4016f21e&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4016f21e"]])

export default __exports__